jQuery(function($){
  
  animateScroll();
  externalLinks();
  scaleBgImages();

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
        }
    }

    $('#account-dropdown').click(function(){
        $(this).find('.account-sub-menu').fadeToggle();
    });

    var runWaypoints = function(){
      var waypoints = $('#waypoint').waypoint(function(direction) {
        // $('#shopify-section-header').toggleClass('lock_nav shopify-section-header-sticky');
      });
    }
    runWaypoints();

    function setupMegaDropdowns() {
        var drops = $('.site-nav .has-dropdown .dropdown');

        drops.each(function(){
            console.log($(this));
        });
    }
    setupMegaDropdowns();

    function runSliders(slider) {
        slider.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1           
        });
    }

    function setupSliders() {
        var sliderTrigger = $('.has-dropdown');

        sliderTrigger.mouseenter(function(){
           var slider = $(this).find($('.dropdown-slider'));
           runSliders(slider);
        })
    }
    setupSliders();

    var runSocial = function(){
      var shareBlocks = $('.social-share');
      var alreadyShared = [];
  
      shareBlocks.each(function(){
        var shareBlock = $(this);
        var shareID = $(this).attr('id');
  
        if($.inArray(shareID,alreadyShared)){
          $(this).find('.share').ShareLink({
                title: shareBlock.find('input.title').val(),
                text: shareBlock.find('input.title').val(),
                image: shareBlock.find('input.image').val(),
                url: shareBlock.find('input.url').val()
            });
  
            alreadyShared.push($(this).attr('id'));
        }
      });
    }
    runSocial();


    function setupTabs() {
      $('ul.tabs').each(function(){
        var active, content, tabs = $(this).find('.tab-nav');
        active = tabs.first().addClass('active');
        content = $(active.attr('href'));
        tabs.not(':first').each(function () {
          $($(this).attr('href')).hide();
        });
        $(this).find('.tab-nav').click(function(e){
          active.removeClass('active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('active');
          content.show();
          return false;
        });
      });
    }
    setupTabs();
});